"use client";

import { useEffect } from "react";

import { shellTransientWindows } from "@/src/features/windows/client/shellTransientWindows";

/** The session-only window the notice shows in (app/components/render/TeamInviteWaiting.tsx). */
export const TEAM_INVITE_WAITING_COMPONENT = "TeamInviteWaiting";
export const TEAM_INVITE_WAITING_WINDOW_ID = "team-invite-waiting";
const TEAM_INVITE_WAITING_WINDOW_SIZE = { width: 420, height: 132 } as const;

/**
 * Shown in the workspace after signing up through an older team invite while
 * the inviter's data was locked: the account uses its own workspace until the
 * inviter opens Smart Manager and their data confirms the invite. The notice
 * is its own window, opened while this stays mounted; closing the window
 * dismisses it for the rest of the session.
 */
export default function TeamInviteWaitingNotice() {
  useEffect(() => {
    shellTransientWindows.show({
      id: TEAM_INVITE_WAITING_WINDOW_ID,
      name: TEAM_INVITE_WAITING_COMPONENT,
      size: TEAM_INVITE_WAITING_WINDOW_SIZE,
      props: { id: TEAM_INVITE_WAITING_WINDOW_ID },
      reason: "Team invite waiting for the inviter",
    });
    return () => shellTransientWindows.close([TEAM_INVITE_WAITING_WINDOW_ID]);
  }, []);
  return null;
}
